class MobileFilterController {
  constructor() {
    this.openFilter = document.getElementById('open-filter');
    this.closeFilter = document.getElementById('close-filter');
    this.filterBox = document.getElementById('filter-box');
    this.dropDown = document.getElementById('dropdown-content');
    this.dateFilterForm = document.getElementById('date-filter-form');
    this.dropDownToggle = document.getElementById('dropbtn-toggle');
    this.closeFilterCross = document.getElementById('close-filter-box-cross');
    this.events();
  }

  events() {
    this.openFilter.addEventListener('click', this.openTheFilter.bind(this));
    this.closeFilter.addEventListener('click', this.closeTheFilter.bind(this));
    this.closeFilterCross.addEventListener('click', this.closeTheFilter.bind(this));
    window.addEventListener('resize', this.checkWidth.bind(this));
    window.addEventListener('DOMContentLoaded', this.checkWidth.bind(this));
  }


  addBlockClass() {
    let screenWidth = window.innerWidth;
    if (screenWidth >= 600) {
      this.dropDown.classList.add('display-block');
    }
  }

  removeBlockClass() {
    let screenWidth = window.innerWidth;
    if (screenWidth >= 600) {
      this.dropDown.classList.remove('display-block');
    }
  }

  openTheFilter() {
    this.dropDown.classList.add('dropdown-content-mobile');
    this.filterBox.classList.add('filter-box-mobile');
    this.dateFilterForm.classList.add('dropdown--mobile');
    this.dropDownToggle.classList.add('hidden');
    document.body.classList.add('no-scroll');
  }

  checkWidth() {
    let screenWidth = window.innerWidth;
    if (screenWidth > 460) {
      this.closeTheFilter();
    }

    if (screenWidth >= 600) {
      this.dateFilterForm.addEventListener('mouseenter', this.addBlockClass.bind(this));
      this.dateFilterForm.addEventListener('mouseleave', this.removeBlockClass.bind(this));
    }
  }

  closeTheFilter() {
    this.dropDown.classList.remove('dropdown-content-mobile');
    this.filterBox.classList.remove('filter-box-mobile');
    this.dateFilterForm.classList.remove('dropdown--mobile');
    this.dropDownToggle.classList.remove('hidden');
    document.body.classList.remove('no-scroll');
  }

}

export default MobileFilterController;